import { useEffect, useState } from "react";
import { Map } from "mapbox-gl";

/**
 * A counter that increments each time the base map style finishes reloading.
 *
 * Reloading the style removes every source & layer that was added to the map, so
 * effects that add their own can depend on this to re-add them.
 */
export const useStyleEpoch = (map: Map | undefined): number => {
  const [epoch, setEpoch] = useState(0);

  useEffect(() => {
    if (!map) return undefined;

    const handleStyleData = () => setEpoch((current) => current + 1);
    const handleStyleDataLoading = () => {
      // Mapbox is a bit overenthusiastic in sending the styledata event, so we use
      // this `once` call (once for each styledataloading) to avoid infinite loops.
      // See https://stackoverflow.com/a/66329525
      map.once("styledata", handleStyleData);
    };
    map.on("styledataloading", handleStyleDataLoading);

    return () => {
      map.off("styledataloading", handleStyleDataLoading);
      map.off("styledata", handleStyleData);
    };
  }, [map]);

  return epoch;
};
